var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"page-back",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('IconComponent',{staticClass:"page-back__icon",attrs:{"name":"arrow-left-line"}}),_c('span',[_vm._v("Вернуться назад")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }